import { render, staticRenderFns } from "./JobStatusRelationForm.vue?vue&type=template&id=4ee83386&"
import script from "./JobStatusRelationForm.vue?vue&type=script&lang=js&"
export * from "./JobStatusRelationForm.vue?vue&type=script&lang=js&"
import style0 from "./JobStatusRelationForm.vue?vue&type=style&index=0&id=4ee83386&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports